import { Button } from 'antd'
import TextArea from 'antd/es/input/TextArea'
import React, { useState } from 'react'
import { useParams } from 'react-router-dom'
import { BodyPartSelector, VERTICAL } from '../move/BodyPartSelector'
import { BODY_PARTS, REASON_CHARS_MINIMUM } from '../../../constants'
import { useUnCompleteSubject } from '../../../hooks/useSubject'
import { FormLabel } from '../../../components/form/FormLabel'

type Props = {
  subject: any
  mutateSubjectData: any
  onClose?: () => void
}

export const UnCompleteDrawer = ({ subject, mutateSubjectData, onClose }: Props) => {
  const { projectId } = useParams() as { projectId: string; siteId: string }

  const [uncompleteReason, setUncompleteReason] = useState<string>('')
  const [selectedBodyParts, setSelectedBodyParts] = useState<string>()
  const [reasonError, setReasonError] = useState<string | null>(null)
  const [bodyPartsError, setBodyPartsError] = useState<string | null>(null)

  const { callUnComplete, isLoading } = useUnCompleteSubject(projectId, subject._id)

  const currentPhase = subject && subject.currentPhase ? subject.currentPhase : {}

  const confirm = () => {
    // If there are body parts options available but no option has been chosen -> set error and leave
    if (plainOptions.length > 0 && !selectedBodyParts) {
      setBodyPartsError('Please select a body part')
      return
    }

    // If the number of characters in the reason text field is less than the required minimum  -> set error and leave
    if (uncompleteReason.length < REASON_CHARS_MINIMUM) {
      setReasonError(`Please provide a reason minimum ${REASON_CHARS_MINIMUM} characters long`)
      return
    }

    const obj = {
      projectId: projectId,
      subjectId: subject._id,
      bodyPart: selectedBodyParts,
      reasonDescription: uncompleteReason,
    }

    return callUnComplete(obj)
      .then((result) => {
        console.log('UnCompleteDrawer > result = ', result)

        mutateSubjectData()
        setUncompleteReason('')
        if (onClose) {
          onClose()
        }

        return result
      })
      .catch((error) => {
        console.log('UnCompleteDrawer > error = ', error)
        return Promise.reject(error)
      })
  }

  const handleTextChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setReasonError(null)
    setUncompleteReason(e.target.value)
  }

  const handleSelectBodyPartChange = (bodyPart: string) => {
    setBodyPartsError(null)
    setSelectedBodyParts(bodyPart)
  }

  const plainOptions = currentPhase?.bodyParts
    ? currentPhase.bodyParts.map((item) => {
        return { bodyPart: item, label: BODY_PARTS[item] || item }
      })
    : []

  return (
    <>
      <div className="row">
        <div className="col-12">
          <h5>Revert Study Completion</h5>
        </div>

        {currentPhase?.bodyParts?.length !== 0 ? (
          <>
            <p className="mt-2">
              Revert the study completion and re-activate the participant. This moves the subject to their previous
              phase
            </p>
            <p className="mt-2">The participant’s device will be re-enabled to continue study participation.</p>

            <p className="fw-bold mt-3 mb-1">Confirm target body part</p>
            <p className="mb-1">Select the target body part and provide a written reason.</p>

            <BodyPartSelector
              className="mb-0 mt-3 col-12"
              bodyparts={plainOptions}
              direction={VERTICAL}
              setSelectedBodyPart={handleSelectBodyPartChange}
            ></BodyPartSelector>
            <div className="col-12" style={{ marginTop: '-8px' }}>
              <p className="p-small text-danger">{bodyPartsError || '\u00A0'}</p>
            </div>
          </>
        ) : (
          <>
            <p className="mt-2">
              Revert the study completion and re-activate the participant. This moves the participant to their previous
              phase
            </p>
            <p className="mt-2 mb-3">The participant’s device will be re-enabled to continue study participation.</p>
          </>
        )}
      </div>
      <div className="col-12 mt-3">
        <FormLabel label="Please provide a reason"></FormLabel>
        <TextArea placeholder="" rows={2} className="mt-1" onChange={handleTextChange} />
      </div>
      <div className="col-12">
        <p className="p-small text-danger">{reasonError || '\u00A0'}</p>
      </div>
      <div className="mt-3 d-flex justify-content-end">
        <Button onClick={onClose}>Cancel</Button>
        <Button className="ms-2" type="primary" onClick={confirm} loading={isLoading}>
          Revert Study Completion
        </Button>
      </div>
    </>
  )
}
